module.exports = {"closeButtonText":"Cerca","thumbNailAlt":"Previsualizar imagen","next":"Siguiente página","previous":"Pagina anterior","addNote":"Agregar una nota..."}


//////////////////
// WEBPACK FOOTER
// ./translations/es-MX.json
// module id = 32
// module chunks = 0